  (function() {
    window.CartPage = window.CartPage || new function() {
    //runs once per page load
    var self = this;
    
    self.updateCart = function() {
      $s.showLoadingOverlay();
      $s.getJson({url: routes.root_url + '?sections=cart_content', success: function(data){
        var section = document.querySelector('.cart-content');
        $s.updateDynamicContent(section, data['cart_content']);
        var summaryWrapper = document.querySelector('#cart .summary-column');
        if (section.querySelector('.cart-items')) {
          summaryWrapper.style.display = '';
        } else {
          summaryWrapper.style.display = 'none';
        }
        $s.globalEval(data['cart_content']);
        $s.hideLoadingOverlay();
      }});
    }

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        data.updates[item.dataset.key] = quantity;
      });
      postUpdate(data);
    }

    function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: routes.cart_url + '/update.js',
        data: data,
        dataType: 'json',
        success: async function(cart) {
          self.updateCart();
        },
        error: $s.addToCartFail
      });
    }
  
  };
  //runs every time #cart div is replaced
  var cart = document.getElementById('cart');
  var itemsCount = 0;
  cart.querySelectorAll('.cart-items .quantity-box input[type=number]').forEach(function(item){
    itemsCount += item.value/1;
  });
  var cartCountElement = document.querySelector('header .cart-count');
  if(cartCountElement) {
    cartCountElement.innerHTML = itemsCount>0?`(${itemsCount})`:'';
  }
  var cartCountElementCart = document.querySelector('#cart .cart-count');
  if(cartCountElementCart) {
    cartCountElementCart.innerHTML = itemsCount>0?`(${itemsCount})`:'';
  }

  cart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      var items = $s.getItemsToUpdate ? $s.getItemsToUpdate(this.closest('.item'), 0) : [this.closest('.item')];
      CartPage.updateItemsQuantity(items, 0);
    });
  });

  cart.querySelectorAll('.cart-items input[type=number]').forEach(function(item) {
    item.addEventListener('change', function(e){
      var items = $s.getItemsToUpdate ? $s.getItemsToUpdate(this.closest('.item'), this.value) : [this.closest('.item')];
      CartPage.updateItemsQuantity(items, this.value);
    });
  });

  

  

  if ($s.validateBundlesInHTML) {
    $s.validateBundlesInHTML(document.querySelectorAll('#cart .item'));
  }
})();